module.exports = __webpack_public_path__ + "media/images/flags/64/Scotland-b1668a716e24910f41aea9de93c9cd9e.png";